var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23648 12.4395L8.25119 5.56641C8.76116 5.86663 11.3327 7.2898 11.748 7.56042L7.7333 14.434C7.29422 15.014 3.68023 13.3198 4.23648 12.4391V12.4395Z",
    fill: "#FBBC04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7714 12.4393L11.7567 5.5666C11.1954 4.63256 9.9866 4.29314 8.99376 4.8448C8.00093 5.39647 7.69861 6.58487 8.25987 7.56062L12.2746 14.4342C12.8358 15.3678 14.0447 15.7072 15.0375 15.1555C15.987 14.6039 16.3327 13.3734 15.7714 12.4402V12.4393Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97362 15.4212C7.08663 15.4212 7.9889 14.5413 7.9889 13.456C7.9889 12.3706 7.08663 11.4907 5.97362 11.4907C4.86061 11.4907 3.95834 12.3706 3.95834 13.456C3.95834 14.5413 4.86061 15.4212 5.97362 15.4212Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAds);
export default __webpack_public_path__ + "static/media/google_ads.ccb42fba5892825841c936c59b3f01b1.svg";
export { ForwardRef as ReactComponent };